
namespace Matrix.Data {

	@Serenity.Decorators.registerClass()
	export class AccountHoldingGrid extends SiteEntityGrid<AccountHoldingRow, any> {
        protected getColumnsKey() { return 'Data.AccountHolding'; }
        protected getDialogType() { return null; }
        protected getIdProperty() { return AccountHoldingRow.idProperty; }
        protected getLocalTextPrefix() { return AccountHoldingRow.localTextPrefix; }
        protected getService() { return AccountHoldingService.baseUrl; }

		protected instanceCode: Serenity.LookupEditor;

        constructor(container: JQuery) {
			super(container);

			this.instanceCode = Serenity.Widget.create({
				type: FormatLookupEditor,
				options: {
					lookupKey: InstanceRow.lookupKey
				},
				init: ed => {
					if (this.useQueryCriteria()) {
						var q = Q.parseQueryString();
						if (typeof q["InstanceCode"] !== "undefined") {
							ed.value = Q.trimToNull(q["InstanceCode"]);
							return;
						}
					}
					ed.value = "DUP";
				},
				element: el => el.attr('placeholder', '-- Instance Code --')
					.css('float', 'left')
					.css('width', '300px')
					.insertAfter(this.toolbar.element.find('.s-QuickSearchBar'))
			});

			this.instanceCode.changeSelect2(e => this.refresh());
		}

		protected onViewSubmit() {
			if (!super.onViewSubmit())
				return false;

			var request = this.view.params as Serenity.ListRequest;
			request.EqualityFilter = request.EqualityFilter || {};
			request.EqualityFilter[AccountHoldingRow.Fields.InstanceCode] = this.instanceCode.value;

			return true;
		}

		protected getButtons() {
			return super.getButtons().filter(x => x.cssClass != "add-button");
		}
    }
}